const _ = require("lodash");
const ShapeVolume = require("./ShapeVolume");
const {hiddenEdgeStyle} = ShapeVolume;
const {V3} = require("./VectorDraw");
const {findAllEdges} = require("./VOverlap");

// Full documentation for each function is in the batex guide.

/**
 * Was getting "Declaration emit for this file requires using private name".
 * This `type` annotation is a workaround. See: https://stackoverflow.com/questions/60009092/declaration-will-not-emit-due-to-private-name-usage
 * @type {unknown}
 */
const CubeVolume = function(ctx, x, y, w, h, settings) {
	if (!(this instanceof CubeVolume)) {
		return new CubeVolume(ctx, x, y, w, h, settings);
	}
	this.sv = ShapeVolume(
		ctx,
		x,
		y,
		w,
		h,
		_.extend({}, settings, {explicitDrawOrder: true})
	);
	this.world = this.sv.world;
};

CubeVolume.prototype.draw = function() {
	this.sv.draw();
};

// Proxy all the ShapeVolume methods unaffected by explicitDrawOrder.

CubeVolume.prototype.dot = function(...args) {
	return this.sv.dot(...args);
};

CubeVolume.prototype.label = function(...args) {
	return this.sv.label(...args);
};

CubeVolume.prototype.edgeLabel = function(...args) {
	return this.sv.edgeLabel(...args);
};

CubeVolume.prototype.measureLine = function(...args) {
	return this.sv.measureLine(...args);
};

CubeVolume.prototype.debugFlag = function(...args) {
	return this.sv.debugFlag(...args);
};

CubeVolume.prototype.box = function(v1, v2, settings) {
	const {
		fill = null,
		topFill = null,
		bottomFill = null,
		leftFill = null,
		rightFill = null,
		frontFill = null,
		backFill = null,
		stroke = null,
		strokeWidth = null,
		skipEdgesHidden = !!fill,
		skipEdgesFront = false,
		skipEdgesBack = false,
		skipEdgesBottom = false,
		skipEdgesTop = false,
		skipEdgesRight = false,
		skipEdgesLeft = false,
	} = settings || {};

	const [minX, minY, minZ] = V3.min([v1, v2]);
	const [maxX, maxY, maxZ] = V3.max([v1, v2]);
	const basePriority = -100000 * minY + 10000 * minZ + 1000 * minX;

	const topFace = [
		V3(minX, minY, maxZ),
		V3(maxX, minY, maxZ),
		V3(maxX, maxY, maxZ),
		V3(minX, maxY, maxZ),
	];
	const bottomFace = [
		V3(minX, minY, minZ),
		V3(maxX, minY, minZ),
		V3(maxX, maxY, minZ),
		V3(minX, maxY, minZ),
	];
	const leftFace = [
		V3(minX, minY, minZ),
		V3(minX, minY, maxZ),
		V3(minX, maxY, maxZ),
		V3(minX, maxY, minZ),
	];
	const rightFace = [
		V3(maxX, minY, minZ),
		V3(maxX, minY, maxZ),
		V3(maxX, maxY, maxZ),
		V3(maxX, maxY, minZ),
	];
	const frontFace = [
		V3(minX, minY, minZ),
		V3(maxX, minY, minZ),
		V3(maxX, minY, maxZ),
		V3(minX, minY, maxZ),
	];
	const backFace = [
		V3(minX, maxY, minZ),
		V3(maxX, maxY, minZ),
		V3(maxX, maxY, maxZ),
		V3(minX, maxY, maxZ),
	];

	const allFaces = [
		frontFace,
		topFace,
		rightFace,
		leftFace,
		bottomFace,
		backFace,
	];
	const allFills = [
		frontFill || fill,
		topFill || fill,
		rightFill || fill,
		leftFill || fill,
		bottomFill || fill,
		backFill || fill,
	];
	const allSkips = [
		skipEdgesFront,
		skipEdgesTop,
		skipEdgesRight,
		skipEdgesLeft,
		skipEdgesBottom,
		skipEdgesBack,
	];

	// Priority of each element is base priority plus:
	// - front-top-right-left-bottom-back (+60, +50, ... +10), edge uses larger
	// - edges (+1) then faces (+0)
	allFaces.forEach((vs, i) => {
		if (allFills[i]) {
			this.world.addFace({
				vs,
				fill: allFills[i],
				priority: basePriority + (60 - 10 * i),
			});
		}
	});
	const edges = findAllEdges(allFaces);
	if (stroke) {
		edges.forEach(({vs, faceInds}) => {
			const [faceI1, faceI2] = faceInds;
			if (allSkips[faceI1] || allSkips[faceI2]) {
				return;
			}
			const isHidden = faceI1 >= 3 && faceI2 >= 3;
			if (skipEdgesHidden && isHidden) {
				return;
			}
			const priority = basePriority + (61 - 10 * Math.min(faceI1, faceI2));
			const worldFace = {vs, stroke, strokeWidth, priority};
			if (isHidden) {
				_.extend(worldFace, hiddenEdgeStyle);
			}
			this.world.addFace(worldFace);
		});
	}
};

module.exports = CubeVolume;
